import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import {
  Button,
  Divider,
  Modal,
  Stack,
  TextInput,
  Text,
  Menu,
} from "@mantine/core";

import { Cubby } from "../../stores/Cubby";
import { MODALS } from "../../helpers/constants";
import { IconFileInvoice, IconKey } from "@tabler/icons-react";
import SendViaBolt11Invoice from "./sendViaBolt11Invoice";
import { TextWithInfo } from "./textWithInfo";
import { TextWithInfoAndIcon } from "../dataDisplay/textWithInfoAndIcon";
import { ARTICLES } from "../../docs/docsIndex";

const SendViaBoltElevenContainer = observer(({ cubby }: { cubby: Cubby }) => {
  return (
    <>
      <Modal
        opened={cubby.currentModal == MODALS.SEND_VIA_BOLT_11_INVOICE}
        onClose={() => {
          cubby.setModal(null);
          cubby.setInvoiceForPayment("");
        }}
        title={
          <TextWithInfoAndIcon
            text="Pay To Lightning Invoice"
            articleSlug={ARTICLES.SENDING_TO_LIGHTING_INVOICE.slug}
            icon={<IconFileInvoice size={24} />}
            cubby={cubby}
            textSize="lg"
          />
        }
      >
        <SendViaBolt11Invoice cubby={cubby} />
      </Modal>
    </>
  );
});

export default SendViaBoltElevenContainer;
